import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DetachedCommentAnchor = _resolveComponent("DetachedCommentAnchor");
    const _component_EditorCell = _resolveComponent("EditorCell");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
            'row-container',
            _ctx.blockWidthClass,
            {
                'contains-cover-image': _ctx.containsCoverImage,
                'contains-cover-video': _ctx.containsCoverVideo,
            },
        ])
    }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsWithoutCell, (comment) => {
            return (_openBlock(), _createBlock(_component_DetachedCommentAnchor, {
                id: comment.id,
                key: comment.id
            }, null, 8, ["id"]));
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cells, (cell) => {
            return (_openBlock(), _createBlock(_component_EditorCell, {
                key: cell.id,
                context: _ctx.context,
                "focused-required-id": _ctx.focusedRequiredId,
                nodes: cell.nodes,
                "cell-width": cell.width,
                "merge-values": _ctx.mergeValues,
                "is-pdf-viewer": _ctx.isPdfViewer,
                "block-width-class": _ctx.blockWidthClass,
                "page-width": _ctx.pageWidth,
                "is-block-toggled": _ctx.isBlockToggled,
                sender: _ctx.sender,
                "pusher-client": _ctx.pusherClient,
                recipient: _ctx.recipient,
                "allowed-to-edit-after-partially-signed": _ctx.allowedToEditAfterPartiallySigned,
                "recipient-input": _ctx.recipientInput,
                "updating-inputs": _ctx.updatingInputs,
                "partially-signed-fields": _ctx.partiallySignedFields,
                "failed-input-updates": _ctx.failedInputUpdates,
                comments: _ctx.filterCommentsByCell(_ctx.comments, cell.id),
                "selected-comment-id": _ctx.selectedCommentId,
                "show-contextual-comments": _ctx.showContextualComments,
                "create-contextual-comment-button-state": _ctx.createContextualCommentButtonState,
                "current-user": _ctx.currentUser,
                "linked-contracts": _ctx.linkedContracts,
                onUpdateInputValue: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update-input-value', $event))),
                onTrackVideo: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('track-video', $event))),
                onObserveNodeVisibility: ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                onPartiallySign: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('partially-sign', $event))),
                onCreateComment: ($event) => (_ctx.$emit('create-comment', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                onSelectComment: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('select-comment', $event))),
                onFetchNewImage: ($event) => (_ctx.$emit('fetch-new-image', Object.assign(Object.assign({}, $event), { targetCellId: cell.id })))
            }, null, 8, ["context", "focused-required-id", "nodes", "cell-width", "merge-values", "is-pdf-viewer", "block-width-class", "page-width", "is-block-toggled", "sender", "pusher-client", "recipient", "allowed-to-edit-after-partially-signed", "recipient-input", "updating-inputs", "partially-signed-fields", "failed-input-updates", "comments", "selected-comment-id", "show-contextual-comments", "create-contextual-comment-button-state", "current-user", "linked-contracts", "onObserveNodeVisibility", "onCreateComment", "onFetchNewImage"]));
        }), 128))
    ], 2));
}
